
export const reportConsole = (message: string, level: string, ...additionalParams: any) => {
    switch (level) {
        case 'error':
            console.error(message, ...additionalParams);
            return;
        case 'warning':
            console.warn(message, ...additionalParams);
            return;
        case 'info': 
            console.info(message, ...additionalParams);
            return;
        case 'message':
            console.log(message, ...additionalParams);
            return;
        case 'debug':
            console.debug(message, ...additionalParams);
            return;
    }
};

export const reportTrace = (obj: any, ...additionalObjs: any) => {
    if (obj) {
        console.trace(obj, ...additionalObjs);
        return;
    }
};

const loggingUtilities = {
    reportConsole,
    reportTrace
};

export default loggingUtilities;